<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    >
    <template slot-scope="scope">
      <el-popover
        v-if="scope.row.orders_id !== null"
        trigger="hover"
        placement="right"
        >
        <el-table
          :data="getData(scope.row)"
          :show-header="false"
          row-class-name="popover-field"
          >
          <el-table-column
            prop="label"
            width="90"
            align="left"
            >
            <template slot-scope="scope">
              {{ scope.row.label }}
            </template>
          </el-table-column>
          <el-table-column
            prop="data"
            width="200"
            align="left"
            >
            <template slot-scope="scope">
              <div
                class="allow-click-copy"
                @click="doCopy(scope.row.data)"
                >
                {{ scope.row.data }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="tool-tip-content">
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
            :open-delay="500"
            :content="$t('api.actions.itemLink.search')"
            >
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-search"
              circle
              @click="updateRoute([{ 'field': 'orders_id', 'value': scope.row.orders_id }])"
              >
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
            :open-delay="500"
            :content="$t('api.actions.itemLink.list')"
            >
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-menu"
              circle
              @click="gotoOrdersList(scope.row.orders_id)"
              >
            </el-button>
          </el-tooltip>
        </div>
        <el-link
          slot="reference"
          @click="$router.push({
          path: '/orders/orders/edit/' + scope.row.orders_id
          })"
          type="info"
          >
          {{ scope.row.orders_id }}
          <span v-if="scope.row.redeem_code">
            <br/>
            {{ getLabelText('orders', 'redeem_code') }}: {{ scope.row.redeem_code }}
          </span>
        </el-link>
      </el-popover>
      <div
        v-else
        v-text="'-'"
        >
      </div>
      <div
        v-if="scope.row.orders_id === null && scope.row.orders_num !== null"
        v-text="scope.row.orders_num"
        >
      </div>
      <item-link
        v-if="scope.row.partner_id"
        displayType="tag"
        base="partner"
        idField="partner_id"
        nameField="partner_name"
        :labelColW="130"
        :dataColW="200"
        :fields="[{label:$t('api.payment.fields.partner_order_id.label'),fname:'partner_order_id'}]"
        :rowData="scope.row"
        effect="plain"
        :disable-transitions="true"
        class="allow-click-copy"
        @click="doCopy(scope.row.partner_name)"
      >
      </item-link>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { getTimeText } from '@/utils/time'
import { getLabelText } from '@/utils/i18n'
import { gotoOrdersList, updateRoute } from '@/utils/route'

export default {
  name: 'orders-field',
  props: {
    labelText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    label: function () {
      return this.labelText || this.$t('api.orders.name')
    }
  },
  methods: {
    doCopy,
    getTimeText,
    getLabelText,
    gotoOrdersList,
    updateRoute,
    getData (row) {
      let list = [{
        label: this.getLabelText('orders', 'id'),
        data: row.orders_id
      }, {
        label: this.$t('api.unhideID'),
        data: row.unhide_orders_id
      }]
      if (row.redeem_code) {
        list.push({
          label: this.getLabelText('orders', 'redeem_code'),
          data: row.redeem_code
        })
      }
      if (row.orders_created_at) {
        list.push({
          label: this.getLabelText('orders', 'created_at'),
          data: this.getTimeText(row.orders_created_at)
        })
      }
      if (row.trade_time) {
        list.push({
          label: this.getLabelText('orders', 'trade_time'),
          data: this.getTimeText(row.trade_time)
        })
      }

      if (row.tz_location) {
        list.push({
          label: this.getLabelText('orders', 'booking_time') + ' (' + this.$t('api.localTZ') + ')',
          data: this.$moment(row.booking_time).tz(row.tz_location).format('YYYY-MM-DD HH:mm:ss Z')
        }, {
          label: this.getLabelText('orders', 'booking_time') + ' (' + this.$t('api.currentTZ') + ')',
          data: this.getTimeText(row.booking_time, true)
        })
      } else {
        list.push({
          label: this.getLabelText('orders', 'booking_time'),
          data: this.getTimeText(row.booking_time, true)
        })
      }
      return list
    }
  },
  watch: {
  }
}
</script>
